var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3306({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0633 21.5499C16.7896 21.5499 18.1891 20.1504 18.1891 18.4241C18.1891 16.6978 16.7896 15.2983 15.0633 15.2983C13.337 15.2983 11.9375 16.6978 11.9375 18.4241C11.9375 20.1504 13.337 21.5499 15.0633 21.5499Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0633 7.48398C16.7896 7.48398 18.1891 6.08452 18.1891 4.3582C18.1891 2.63188 16.7896 1.23242 15.0633 1.23242C13.337 1.23242 11.9375 2.63188 11.9375 4.3582C11.9375 6.08452 13.337 7.48398 15.0633 7.48398Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12578 14.5172C5.8521 14.5172 7.25156 13.1177 7.25156 11.3914C7.25156 9.66508 5.8521 8.26562 4.12578 8.26562C2.39946 8.26562 1 9.66508 1 11.3914C1 13.1177 2.39946 14.5172 4.12578 14.5172Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4409 6.04834L6.75586 9.70159",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75586 13.0811L12.4409 16.7343",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3306);
export default __webpack_public_path__ + "static/media/Group 3306.9e15aa4b71234f824f7fa9b10844cbb5.svg";
export { ForwardRef as ReactComponent };